import React from 'react'
import {cn} from '@/lib/utils'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {accountFormLabelInput} from '../account-drawer/constants/accountFormLabelInput'
import {CategoryProductGrid, categoryProductGridPerPageLimitInputField} from './categoryProductGrid'
import {injectedGridContentItemsDefinition} from './constants/injectedGridContent'
import {getStandardBreadcrumbInputs, breadcrumbTypes} from '../breadcrumb/utils'
import {StandardBreadcrumb} from '../breadcrumb/standardBreadcrumb'
import {DrawerFilters} from '../DrawerFilters/DrawerFilters'
import SortPopover from '../../sort/sortPopover'
import {useCioFacetSelector} from '@/context/cio-facet'

type PlpBuilderBlockProps = {
    attributes?: {
        className?: string
        restAttributes?: React.HTMLAttributes<HTMLDivElement>
    }
    perPageLimit?: number
    accountFormLabels?: any
    injectedContentItems?: any
    customCrumbs?: any
    categoryCrumbs?: any
    type?: any
    separator?: string
    includeHome?: boolean
    builderBlock?: any
}

const PlpBuilderBlock = ({
    attributes,
    perPageLimit,
    accountFormLabels,
    injectedContentItems,
    customCrumbs,
    categoryCrumbs,
    type,
    separator,
    includeHome,
    builderBlock
}: PlpBuilderBlockProps) => {
    const config = getConfig()
    const {
        app: {threeLetter}
    } = config
    const {className, restAttributes} = attributes || {}
    const cioFacetContext = useCioFacetSelector((context) => context)
    const TotalResults = cioFacetContext?.state?.totalResults?.responseTotal || 0

    return (
        <div
            {...restAttributes}
            className={cn('p-3 lg:p-0 lg:container flex flex-col ', className)}
            data-testid="plp-builder-block"
        >
            <StandardBreadcrumb
                type={type || breadcrumbTypes.CATEGORY}
                customCrumbs={customCrumbs || []}
                categoryCrumbs={categoryCrumbs || []}
                separator={separator || '>'}
                builderBlock={builderBlock}
                includeHome={includeHome || true}
                data-testid={'plpBuilderBlock-StandardBreadcrumb'}
            />
            <div className="flex justify-between">
                <DrawerFilters data-testid={'plpBuilderBlock-DrawerFilters'} />
                <div className="flex flex-col justify-center items-center">
                    <div>{TotalResults} Products</div>
                    <h2>All {threeLetter} eligible</h2>
                </div>
                <SortPopover data-testid={'plpBuilderBlock-SortPopover'} />
            </div>
            <div className="w-full">
                <CategoryProductGrid
                    accountFormLabels={accountFormLabels}
                    perPageLimit={perPageLimit || 60}
                    injectedContentItems={injectedContentItems}
                    data-testid={'plpBuilderBlock-CategoryProductGrid'}
                />
            </div>
        </div>
    )
}

export const PlpBuilderBlockDefinition = {
    component: PlpBuilderBlock,
    name: 'PlpBuilderBlock',
    noWrap: true,
    inputs: [
        categoryProductGridPerPageLimitInputField,
        accountFormLabelInput,
        injectedGridContentItemsDefinition,
        ...getStandardBreadcrumbInputs()
    ]
}
